export default function CTASection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-4xl mx-auto text-center">
        <div className="rounded-2xl overflow-hidden mb-10">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20textile%20patterns%20in%20warm%20earth%20tones%20of%20terracotta%20sand%20and%20olive%20green%20draped%20elegantly%20across%20cream%20backdrop%2C%20soft%20gradient%20lighting%2C%20editorial%20texture%20study%2C%20organic%20fabric%20folds%20and%20wrinkles%2C%20luxurious%20natural%20linen%20and%20cotton%20blend%2C%20artistic%20minimalist%20composition&width=1200&height=500&seq=cta-banner-v2&orientation=landscape"
            alt="Kakobuy Spreadsheet"
            className="w-full h-56 md:h-72 object-cover object-top"
          />
        </div>

        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 tracking-tight max-w-2xl mx-auto leading-tight">
          Gotowy, aby odkryć <span className="text-primary-600">najlepsze finds</span>?
        </h2>
        <p className="text-foreground-600 mt-4 text-sm max-w-lg mx-auto leading-relaxed">
          Dołącz do tysięcy polskich kupujących, którzy codziennie korzystają z Kakobuy Spreadsheet, aby znajdować najlepsze okazje i produkty.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap inline-flex items-center gap-2"
          >
            <i className="ri-external-link-line"></i>
            kakobuy sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap inline-flex items-center gap-2"
          >
            <i className="ri-shopping-bag-3-line"></i>
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}